
const ModuleListMap = {
    "Quotation":{url:"/quotation-list",query:"quotationlist"},
    "Maintenance":{url:"/maintenance-list",query:"maintenancelist"},
    "Cleaning":{url:"/cleaning-list",query:"cleaninglist"},
    "Billing":{url:"/billing-list",query:"billinglist"},
    "Fine":{url:"/fine-list",query:"finelist"},
    "Transfer":{url:"/transfer-list",query:"transferlist"},
    "Clearance":{url:"/clearance-list",query:"clearancelist"},
    "Preparation":{url:"/preparation-list",query:"preparationlist"},
    "Feedback":{url:"/feedback-list",query:"feedbacklist"},
};
export default ModuleListMap;
